import axios from "axios";

const FORM_ENDPOINT =
  "https://script.google.com/macros/s/AKfycbxdFIJtPssUqeeWH7mDINc0X_g-rx5DHBOPwLiZbUIYzZcMYUybj09ObtQAnUhVtk-_/exec";

export const submitInquiry = (data) =>
  axios.post(FORM_ENDPOINT, JSON.stringify(data), {
    headers: { "Content-Type": "text/plain;charset=utf-8" },
  });

export const subscribeNewsletter = (email) =>
  axios.post(
    FORM_ENDPOINT,
    JSON.stringify({ type: "newsletter", email }),
    { headers: { "Content-Type": "text/plain;charset=utf-8" } },
  );
